import * as React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { aboutDataCountsRequest } from '../../app/About/actions';
import './About.css';
import DBImage from '../../assets/db.webp';
import { ReleaseNotes } from './ReleaseNotes';

const cardsData = [
  {
    cardName: 'Funding Calls',
    responseField: 'grantsCount',
    image: DBImage,
  },
  {
    cardName: 'Funded Projects',
    responseField: 'projectsCount',
    image: DBImage,
  },
  {
    cardName: 'Funded Organizations',
    responseField: 'organizationsCount',
    image: DBImage,
  },
];

const About: React.FC = React.memo(() => {
  const dispatch = useDispatch();
  const { result, isFetching, lastFetched } = useSelector((state: any) => state.about);
  const [animatedCounts, setAnimatedCounts] = useState<{ [key: string]: number }>({});

  useEffect(() => {
    const isDataStale = !lastFetched || Date.now() - lastFetched > 5 * 60 * 1000;
    if (!result || Object.keys(result).length === 0 || isDataStale) {
      dispatch(aboutDataCountsRequest());
    }
  }, [dispatch, result, lastFetched]);

  useEffect(() => {
    if (!result || isFetching) return;

    cardsData.forEach((card) => {
      const targetValue = result[card.responseField] || 0;
      if (targetValue === 0) return;

      const startTime = Date.now();
      const animate = () => {
        const progress = Math.min((Date.now() - startTime) / 2000, 1);
        const currentValue = Math.floor(targetValue * progress);

        setAnimatedCounts((prev) => ({ ...prev, [card.responseField]: currentValue }));

        if (progress < 1) {
          requestAnimationFrame(animate);
        }
      };
      requestAnimationFrame(animate);
    });
  }, [result, isFetching]);

  return (
    <div className="about-page">
      <span className="heading">Database Size</span>
      <div className="card">
        {cardsData.map((card) => (
          <div className="card-item" key={card.responseField}>
            <img src={card.image} alt="database" className="db-image" />
            <div className="data-counts">
              {!isFetching && (animatedCounts[card.responseField] || 0).toLocaleString()}
            </div>
            <div className="card-name">{card.cardName}</div>
          </div>
        ))}
      </div>
      <div className='release-notes-card'>
        <ReleaseNotes />
      </div>
    </div>
  );
});

export const AboutPage = About;
